import { render, staticRenderFns } from "./KnowledgeDetail.vue?vue&type=template&id=83e19900&scoped=true&"
import script from "./KnowledgeDetail.vue?vue&type=script&lang=js&"
export * from "./KnowledgeDetail.vue?vue&type=script&lang=js&"
import style0 from "./KnowledgeDetail.vue?vue&type=style&index=0&id=83e19900&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "83e19900",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!D:/Coding/farmerspace/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib'
import { VContainer } from 'vuetify/lib'
import { VFlex } from 'vuetify/lib'
import { VImg } from 'vuetify/lib'
import { VLayout } from 'vuetify/lib'
import { VProgressCircular } from 'vuetify/lib'
import { VTextarea } from 'vuetify/lib'
installComponents(component, {VBtn,VContainer,VFlex,VImg,VLayout,VProgressCircular,VTextarea})
